import * as MetricTypes from 'reporting-data/constants/metricTypes';
import { DESC } from 'reporting-data/constants/sortOrder';
import { getDimensions, getMetrics } from 'reporting-data/report/configReportGetters';
import { isMetricReportEditorSchema } from 'reporting-data/tsTypes/editorTypes';
import { isUnifiedAnalyticsReport } from 'reporting-data/tsTypes/reportTypes';
import { BaseMetricEditor } from './BaseMetricEditor';
import { fromJS } from 'immutable';
import { MAX_NUM_OF_METRICS } from 'reporting-data/constants/limits';
import { fromMetricKey, toMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
import { ReportOptionsCategories } from '../../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import getConfigDataType from '../common/getConfigDataType';
import { isSingleObjectReport } from '../common/reportTypeValidators';
import { EMAIL } from 'reporting-data/constants/dataTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getSort = metric => {
  const {
    property,
    metricTypes
  } = metric;
  return [{
    property,
    metricType: metricTypes && metricTypes.length > 0 ? metricTypes[0] : MetricTypes.SUM,
    order: DESC
  }];
};
const CUSTOM_DATA_TYPE_ALLOW_LIST = [EMAIL];
export const strategy = {
  getCurrentValue: report => {
    const configReport = report;
    return getMetrics(configReport).map(metric => toMetricKey({
      property: metric.get('property'),
      type: metric.getIn(['metricTypes', 0])
    })).toJS();
  },
  getDataType: getConfigDataType,
  isSupportedForReport: report => {
    return isSingleObjectReport(report) || isUnifiedAnalyticsReport(report) || CUSTOM_DATA_TYPE_ALLOW_LIST.includes(getConfigDataType(report));
  },
  updateReport: (report, metrics) => {
    const populatedMetrics = metrics.map(metric => {
      const {
        property,
        type
      } = fromMetricKey(metric);
      return {
        property,
        metricTypes: [type]
      };
    });
    const sortMetric = populatedMetrics[0];
    return report.setIn(['config', 'metrics'], fromJS(populatedMetrics)).setIn(['config', 'sort'], fromJS(getSort(sortMetric)));
  },
  getSelectionLimit: report => {
    const configReport = report;
    return getDimensions(configReport).size > 1 ? 1 : MAX_NUM_OF_METRICS;
  }
};
const SingleObjectMetricsEditorComponent = props => {
  return /*#__PURE__*/_jsx(BaseMetricEditor, Object.assign({}, props, {
    strategy: strategy,
    schema: props.schema
  }));
};
export const SingleObjectMetricsEditor = {
  matchesEditorType: (report, schema) => {
    if (!isMetricReportEditorSchema(schema)) {
      return false;
    }
    return strategy.isSupportedForReport(report);
  },
  EditorComponent: SingleObjectMetricsEditorComponent,
  category: ReportOptionsCategories.Define
};